import { PaddingType } from 'common/types/styleTypes'
import { mobilePaddingsCss, paddingsCss } from 'common/utils/styleUtilsNew'
import styled, { css } from 'styled-components'

interface SearchWrapperUiStylesInterface {
  padding?: PaddingType
  mobilePadding?: Partial<PaddingType>
}

export const SearchWrapperUi = styled.div<SearchWrapperUiStylesInterface>`
  ${paddingsCss};

  ${p =>
    p.theme.isEditorMobileMode &&
    css`
    ${mobilePaddingsCss}
  `}
  ${p => p.theme.phone} {
    ${mobilePaddingsCss}
  }
`
